
























































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Modal from '@/components/Modal.vue'
import { StatementModule } from '@/store/modules/statement.module'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  props: {
    statement: {
      type: Object
    }
  },
  components: {
    LoaderWrapper,
    ScrollView,
    DateTimeLabel,
    Modal,
    Icon
  }
})
export default class TrackingMail extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)

  scrollSettings: any = {
    maxScrollbarLength: 60
  }
  isLoading: boolean = false

  get trackingEvents () {
    const events = this.$store.state.statement.trackingEvents || []
    this.isTracked && events.unshift(
      {
        name: 'In Process',
        time: this.$props.statement.dateMailed
      }
    )
    return events
  }

  get isTracked () {
    return this.$props.statement.lobLetterId || this.$props.statement.trackingNumber
  }

  get lobId () {
    return this.$store.state.statement.trackingLetterId
  }

  isPassed (eventName: string) {
    return this.trackingEvents
      ? !!this.trackingEvents.find((event: any) => event.name === eventName)
      : false
  }

  getEventLabel (name: string, index: number) {
    const NAMES_MAP: { [k: string]: string } = {
      'Returned to Sender': 'Returned'
    }

    if (index === this.trackingEvents.length - 1 && name === 'Processed for Delivery') {
      return 'Delivered'
    }
    if (name === 'Processed for Delivery') {
      return 'Processed for\n Delivery'
    }
    return NAMES_MAP[name] || name
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.statementModuleInstance.fetchStatementTrackingInfo(this.$props.statement.id)
      const container = (this.$refs.scrollContainer as Vue).$el
      container.scrollLeft = container.scrollWidth
    } finally {
      this.isLoading = false
    }
  }

  beforeDestroy () {
    this.statementModuleInstance.resetStatementTrackingEvents()
  }
}
